import React from "react";

class Mask extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShow: false,
    };
  }

  show() {
    this.setState({ isShow: true });
  }

  hide() {
    this.setState({ isShow: false });
  }

  render() {
    const { className, children } = this.props;
    const { isShow } = this.state;

    return (
      <React.Fragment>
        <div
          className={`mask-container ${className || ""}`}
          style={{ display: isShow ? "flex" : "none" }}
        >
          <div className="mask-container-content">{children}</div>
        </div>
      </React.Fragment>
    );
  }
}

export default Mask;
